import React, { useState } from 'react'
import Popup from '../../components/Popup'
import { httpClient } from 'funcs'

type Props = {
  onClose: () => void
  onSuccess: () => void
  onError: (err: any) => void
}

function BecomePartnerInfoPopup ({ onClose, onSuccess, onError }: Props) {
  const [sending, setSending] = useState(false)

  async function handleSubmit () {
    setSending(true)
    try {
      await httpClient.post('/partner-program/request-become-partner')
      onSuccess()
      onClose()
    } catch (err) {
      onError(err)
    } finally {
      setSending(false)
    }
  }

  return (
    <Popup onClose={onClose}>
      <div className="become-partner-info-popup ui-kit-v2">
        <div className="H3_21_v2">Партнёрская программа ОкиДоки</div>
        <div className="become-partner-info-content">
          <div className="become-partner-info-section">
            <div className="Subheader_17">Чем выгодна партнёрка для вас</div>
            <p className="Body_16_v2_secondary">
              Вы получаете 20% комиссии от всех покупок привлечённых клиентов в течение 3 лет. Дополнительный доход без затрат на рекламу — просто делитесь ссылкой или промокодом.
            </p>
          </div>
          <div className="become-partner-info-section">
            <div className="Subheader_17">Чем выгодна для ваших клиентов</div>
            <p className="Body_16_v2_secondary">
              При первой покупке по вашей ссылке клиент получает +30% к количеству договоров из тарифа. Вы даёте им реальную выгоду, а не просто рекламу.
            </p>
          </div>
          <div className="become-partner-info-section">
            <div className="Subheader_17">Как происходят выплаты</div>
            <p className="Body_16_v2_secondary">
              Выплаты на реквизиты ООО, ИП или самозанятого раз в месяц. Отчёты по покупкам и вознаграждению — в личном кабинете в закладке «Отчеты».
            </p>
          </div>
          <div className="become-partner-info-section">
            <div className="Subheader_17">Кому подойдёт партнёрка</div>
            <ul className="Body_16_v2_secondary become-partner-info-list">
              <li><strong>Владельцы сервисов с API</strong> — CRM, стартапы и другие продукты, интегрируйте ОкиДоки по API и получайте вознаграждение</li>
              <li><strong>Интеграторы</strong> — добавляйте ОкиДоки в свои CRM, календари бронирований и другие системы</li>
              <li><strong>Лидеры мнений</strong> — рекомендуйте сервис своей аудитории и получайте вознаграждение</li>
              <li><strong>Те, кто привлекает клиентов</strong> — агентства, консультанты, маркетологи и все, кто может привести клиентов в ОкиДоки</li>
            </ul>
          </div>
          <div className="become-partner-info-submit">
            <button
              type="button"
              className="new action-button primary"
              disabled={sending}
              onClick={handleSubmit}
            >
              <span className="button-text">
                {sending ? 'Отправка…' : 'Подать заявку'}
              </span>
            </button>
          </div>
        </div>
      </div>
    </Popup>
  )
}

export default BecomePartnerInfoPopup
